<template>
	<span v-if="_visible" class="test-as-user">
		<span v-if="selected">
			<b-badge variant="info">
				<i class="fas fa-user-secret"></i>
				Test en tant que : {{ selected.identifiant }}
			</b-badge>
			<b-button variant="link" size="sm" @click="clear" title="Arrêter le test">
				<i class="fas fa-times"></i>
			</b-button>
		</span>
		<b-button v-else variant="outline-secondary" size="sm" @click="open">
			<i class="fas fa-user-secret"></i> Tester en tant que...
		</b-button>

		<b-modal v-model="show_modal" title="Tester en tant qu'un autre utilisateur" @shown="load_users" hide-footer>
			<b-form-input
				v-model="search"
				placeholder="Rechercher (identifiant, nom...)"
				@input="on_search_input"
				class="mb-3"
			></b-form-input>

			<p v-if="loading" class="text-muted"><i class="fas fa-spinner fa-spin"></i> Chargement...</p>
			<p v-else-if="users_list.length == 0" class="text-muted">Aucun utilisateur trouvé.</p>

			<b-list-group v-else>
				<b-list-group-item
					v-for="u in users_list"
					:key="u.uid"
					button
					@click="select(u)"
				>
					{{ u.identifiant }}
					<span v-if="u.nom || u.prenom" class="text-muted"> - {{ u.prenom }} {{ u.nom }}</span>
				</b-list-group-item>
			</b-list-group>
		</b-modal>
	</span>
</template>

<script>
	import store from "../store";
	import client from "../services/client.js";
	import users_service from "../services/users.js";

	// Composant réutilisable "tester en tant qu'un autre utilisateur", pour les éditeurs
	// (code, tableau de bord, validation, vue multitable). L'état sélectionné (jwt de test)
	// est gardé en LOCAL (data() de ce composant), jamais dans le store global : il est
	// remonté au parent explicitement via l'évènement "change", pour être utilisé
	// uniquement sur des actions de test/prévisualisation - jamais sur les actions de
	// sauvegarde/publication.
	export default {
		name: "test_as_user",
		data() {
			return {
				show_modal: false,
				loading: false,
				search: "",
				users_list: [],
				selected: null,
				search_timeout: null
			};
		},
		computed: {
			_visible() {
				var rules = store.state.user && store.state.user.rules;
				return !rules || !!rules.utilisateurs;
			}
		},
		methods: {
			open() {
				this.show_modal = true;
			},
			on_search_input() {
				clearTimeout(this.search_timeout);
				this.search_timeout = setTimeout(() => {
					this.load_users();
				}, 400);
			},
			async load_users() {
				this.loading = true;
				try {
					var data = await client.getClientUsers({ search: this.search, limit: 20 });
					this.users_list = (data && data.users) || [];
				} finally {
					this.loading = false;
				}
			},
			async select(u) {
				var result = await users_service.generateTestJwt(u.uid);
				if (!result || !result.jwt) {
					var title = "Impossible de générer un test pour cet utilisateur";
					if (result && result.error == 401)
						title = "Vous n'avez pas le droit de gérer cet utilisateur (hors de votre périmètre)";
					else if (result && result.error == 404)
						title = "Utilisateur introuvable";
					this.$notify({
						group: "info",
						title: title,
						type: "error",
					});
					return;
				}
				// groups (en plus des infos d'affichage) : nécessaire pour que les composants
				// vueComponent personnalisés (cf dashboard/vueComponent.vue :: extendComponentOptions)
				// puissent reconstituer un objet "user" correct pour l'utilisateur simulé - sans
				// cela, ils retombent silencieusement sur le VRAI utilisateur (store.state.user)
				// pour toute logique dépendant des groupes.
				this.selected = {
					uid: u.uid,
					identifiant: u.identifiant,
					nom: u.nom,
					prenom: u.prenom,
					groups: u.groups,
					details: u.details,
					jwt: result.jwt
				};
				this.show_modal = false;
				this.$emit("change", this.selected);
			},
			clear() {
				this.selected = null;
				this.$emit("change", null);
			}
		}
	};
</script>

<style scoped>
.test-as-user {
	display: inline-block;
	margin-left: 8px;
}
</style>
